import React from "react";
// import DialogActions from "@mui/material/DialogActions";
// import { DialogContent } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
// import useTailwindBrand from "../../../Theme/useTailwindBrand";
import { DataDilogLayout } from "../../../Objects/interfaces/AppInterface";
import {
  BootstrapDialog,
  Transition,
} from "../../../Utils/Function";
// import { BrandButton } from "../../../Components/shared";
// import TeachrCard from "./TeachrCard";

// interface CourseProposal {
//   id: number;
//   teacherName: string;
//   startDatetime: string;
//   endDatetime: string;
//   description?: string;
//   isRemote: boolean;
//   isCourseInTheHour: boolean;
//   duration?: number;
//   creationDatetime?: Date;
//   priceRate: number;
//   finalTotal: number;
//   averageNote: any;
//   teacherId: number | undefined;
// }

const ClientDialogLayout = (data: DataDilogLayout) => {
  //   const { classes, common, brandConfig, brand } = useTailwindBrand();
  return (
    <BootstrapDialog
      open={data.open}
      TransitionComponent={Transition}
      keepMounted
      maxWidth={data?.maxWidth ?? "sm"}
    >
      <div className="flex justify-end mx-5">
        <IconButton
          edge="end"
          color="inherit"
          onClick={data.handleCloseIcon ?? data.handleClose}
          aria-label="close"
        >
          <CancelRoundedIcon sx={{ color: "#FF724F" }} />
        </IconButton>
      </div>

      <div>{data.text}</div>
      {data.children}
    </BootstrapDialog>
  );
};

export default ClientDialogLayout;